module.exports = __webpack_public_path__ + "img/logo_row_zh_CN.aa1b57ea.svg";